var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchMini = function SvgSearchMini(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7638 12.1195C11.0799 11.7752 11.0799 11.2461 10.7638 10.9018L8.17341 8.08042C8.75564 7.11664 8.98884 5.95185 8.82785 4.81155C8.66687 3.67126 8.12316 2.63658 7.30198 1.90785C6.48081 1.17911 5.44059 0.808158 4.38272 0.866807C3.32486 0.925456 2.3246 1.40954 1.5756 2.22532C0.82661 3.04111 0.382166 4.13057 0.328319 5.28278C0.274472 6.43498 0.615053 7.56797 1.28412 8.46237C1.95319 9.35678 2.90315 9.94898 3.95008 10.1243C4.99701 10.2997 6.06644 10.0457 6.9513 9.41152L9.43755 12.1195C9.79427 12.508 10.4071 12.508 10.7638 12.1195ZM1.54592 5.52073C1.54592 3.68582 2.91652 2.19299 4.60119 2.19299C6.28587 2.19299 7.65646 3.68582 7.65646 5.52073C7.65646 7.35564 6.28587 8.84846 4.60119 8.84846C2.91652 8.84846 1.54592 7.35564 1.54592 5.52073Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchMini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-mini.cccbeced.svg";
export { ForwardRef as ReactComponent };